module.exports = __webpack_public_path__ + "img/car.89efec70.svg";